import axios from '../utils/axios';

export default function updateUnverifiedCompany(recId,companyId,data) {
    return (
        axios.post('/admin/' + recId +'/companyManagement/v1/unverified-companies/'+companyId,  data )
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}